import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import {
  PaginationOptionsDto,
  PaginationResultsDto,
  ScheduledHeroEventListResponseDto
} from '@whetstoneeducation/hero-common';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppEventService } from '../events.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TableFilterOptions } from '../../../shared/tables/table-filters/table-filters';
import { TableFiltersPageKeyEnum } from '../../../shared/tables/table-filters/table-filters-page-key.enum';

@Injectable({ providedIn: 'root' })
export class AppHistoricalScheduledHeroEventListResolver extends BaseResolver<
  PaginationResultsDto<ScheduledHeroEventListResponseDto>
> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public eventService: AppEventService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(
    route: ActivatedRouteSnapshot
  ): Promise<PaginationResultsDto<ScheduledHeroEventListResponseDto>> {
    const heroEventId = route.paramMap.get('id');
    return this.eventService.getHistoricalScheduledHeroEventsByHeroEventId(
      parseInt(heroEventId),
      new PaginationOptionsDto(
        TableFilterOptions.getPageDefault(
          TableFiltersPageKeyEnum.HISTORICAL_SCHEDULED_HERO_EVENT_LIST
        )
      )
    );
  }
}
